import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSearchAdvertisment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات اسلاید را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetSearchAdvertisment = (myPC, search, bool, callback) => {
    MyAxios.get(`Admin_SearchAdvManage?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateSearchAdvertisment = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.put(`Admin_SearchAdvManage`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    validate,
    GetSearchAdvertisment,
    UpdateSearchAdvertisment,
  };
}
